/** @format */

import React, { useReducer } from "react";
import { UiReducer } from "../reducers/UiReducer";

export const UiContext = React.createContext();

export default function UiContextProvider(props) {

  function checkLocalStorage(item) {
    //if getItem is not null, then set the dark mode to true

    if (localStorage.getItem(item) === "true") {
      return true;
    } else if (localStorage.getItem(item) === null) {
      return true;
    } else return false;
  }

  let initialState = {
    isDarkMode: checkLocalStorage("isDarkMode"),
    isSearchOpen: false,
    isGenreOpen: false,

  };
  const [uiState, dispatch] = useReducer(UiReducer, initialState);

  return (
    <UiContext.Provider value={{ uiState, dispatch }}>
      {props.children}
    </UiContext.Provider>
  );
}
